import { useEffect, useState } from "react";

// Scidoo reviews widget, isolated in an iframe that reports its own height.
export const ScidooReviewsWidget = () => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const handler = (e) => {
      if (e.origin === window.location.origin && e.data?.type === "scidoo-reviews-height" && e.data.height > 0) {
        setHeight(e.data.height);
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  return (
    <section className={height > 20 ? "py-10 md:py-14 bg-background" : ""} data-testid="scidoo-reviews-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <iframe
          src="/scidoo-reviews.html"
          title="Recensioni"
          loading="lazy"
          scrolling="no"
          style={{ width: "100%", height: `${height}px`, border: "none", overflow: "hidden", display: "block" }}
          data-testid="scidoo-reviews-widget"
        />
      </div>
    </section>
  );
};

export default ScidooReviewsWidget;
